<template>
  <v-row>
    <v-col cols="12" md="12">
      <BaseBlock title="Page pour utilisateurs authentifiés et autorisés">
        <h2 class="subtitle-1 font-weight-bold">
          Page pour utilisateurs authentifiés et autorisés
        </h2>
        <p>
          Cette page n'est accessible qu'aux utilisateurs connectés et ayant un
          rôle spécifique
        </p>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";

export default {
  name: "AuthAndAutorizedPage",
  components: { BaseBlock },
};
</script>
